/**
 * Returns non empty object or undefined
 */
export const nonEmptyObjectOrUndefined = <
  T extends { [Key in TKey]: unknown },
  TKey extends string,
>(
  object: T,
): T | undefined => (Object.keys(object).length > 0 ? object : undefined);
